// extracted by mini-css-extract-plugin
export default {"ctrbox":"Sidebar_ctrbox__oipl3","title":"Sidebar_title__MozHC","att":"Sidebar_att__O5yqG"};